import { invalidateExperimentDetails } from "@app/queries/experiment";
import { updateExperimentStatus } from "@app/state/actions";
import { useWebSocket } from "@lib/websocket/useWebSocket";

/** Keeps experiment details/status in sync with server-pushed updates. */
export function useSubscribeExperimentWebsocketEvents(): void {
  useWebSocket("experiment.update", async ({ payload: { id, status } }) => {
    updateExperimentStatus(id, status);
    await invalidateExperimentDetails(id);
  });
}
